/* eslint-disable */
import React from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';
import lockr from 'lockr';
import { notification } from 'antd';
import { isUndefined } from 'underscore';

import NotFound from '../../pages/NotFound';

const {
    AUTH_KEY,
    LOCALSTORAGE_EXPIRES_KEY,
    LOCALSTORAGE_EXPIRES,
} = require('../constants').default;

const getRole = () => {
    let role = 'admin';

    switch (lockr.get('USER_ROLE')) {
    case 1:
        role = 'admin';
        break;
    case 2:
        role = 'scorchsoft';
        break;
    case 3:
        break;
    case 4:
        role = 'patient';
        break;
    case 5:
        role = 'clinician';
        break;
    default:
    }

    return role ;
}
const onlyAuthorisedAllowed = () => {
    const response = lockr.get(AUTH_KEY);
    if (!isUndefined(response)) {
        const authDate = lockr.get(LOCALSTORAGE_EXPIRES_KEY);
        if (!isUndefined(authDate)) {
            const parsedAuthDate = new Date(authDate);
            const now = new Date();
            const differenceMilliseconds = now - parsedAuthDate;
            const differenceMinutes = Math.floor(differenceMilliseconds / 1000 / 60);
            if (differenceMinutes >= LOCALSTORAGE_EXPIRES) {
                notification.error({ message: 'Error', description: 'Session expired. Please login again.' });
                return false;
            }
        } else {
            notification.error({ message: 'Error', description: 'Session expired. Please login again.' });
            return false;
        }
        return true;
    }
    return false;
};

const DefaultRoute = ({ exact, path, component }) => <Route exact={exact} path={path || '/'} component={component} />;
const AuthRoute = ({ exact, path, component: Component, role = '', allowedOnlyRoles = [] }) => {
    const isValidRole = allowedOnlyRoles.includes(getRole());

    if (allowedOnlyRoles.length > 0 && !isValidRole) {
        notification.error({ message: 'Error', description: 'You are trying to access a page which either doesn\'t exist or you don\'t have sufficient permissions to access.' });
        // @todo Generates error because transitioning in the middle of component life cycle. Need to figure a clean way
        return <Redirect to="/" />;
    }

    return <Route exact={exact} path={path || '/'} render={() => (onlyAuthorisedAllowed() ? <Component /> : <Redirect to="/" />)} />;
}
const LogoutRoute = ({ exact, path, persistor }) => {
    lockr.rm(AUTH_KEY);
    lockr.rm(LOCALSTORAGE_EXPIRES_KEY);
    lockr.rm(LOCALSTORAGE_EXPIRES);

    localStorage.clear();
    lockr.flush();
    persistor.flush();
    persistor.purge();
    window.location.href = '/';
}

const CoreRouter = ({ children }) => (
    <Switch>
        {children}
        <DefaultRoute component={NotFound} />
    </Switch>
);

export {
    CoreRouter,
    onlyAuthorisedAllowed,
    DefaultRoute,
    AuthRoute,
    LogoutRoute,
};
